
function initMap() {
    // Setup map and options
    var map = new google.maps.Map(document.querySelector("#map-canvas"), {
        mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    var bounds  = new google.maps.LatLngBounds();

    var list = document.querySelector("#shop-list");

    var sublist = document.createElement("ul");
    list.appendChild(sublist);

    var activeInfoWindow = null;

    // Get the Json file data
    $.getJSON("//vpuyfyxacapt.shop/cdn/shop/t/15/assets/shop-locations.json?v=144076462624604314041793360222", function(data) {


        // Loop through the data
        $.each(data, function(key, data) {

            var myLatlng = new google.maps.LatLng(data.lat, data.lng); // set position


            if (data.www) {
                var www = data.www;
            }
            if (data.insta) {
                var insta = data.insta;
            }
            if (data.fb) {
                var fb = data.fb;
            }

            // Add marker to map
            var marker = new google.maps.Marker({
                position: myLatlng,
                map: map,
            });


            // Set info window content
            var infoContent = '<strong>' + data.name + '</strong>';
            infoContent+= '<p>' + data.address + '</p>';
            if (www) {
                infoContent+= '<p><a href="https://' + www + '" target="_blank" rel="nofollow">Webseite / Shop</a></p>';
            }
            if (fb) {
                infoContent+= '<p><a href="https://www.facebook.com/' + fb + '/" target="_blank" rel="nofollow">Facebook</a></p>';
            }
            if (insta) {
                infoContent+= '<p><a href="https://www.instagram.com/' + insta + '/" target="_blank" rel="nofollow">Instagram</a></p>';
            }

            // Add info window
            marker.info = new google.maps.InfoWindow({
                content: infoContent
            });

            // Add listener for info window
            google.maps.event.addListener(marker, 'click', function() {
                if (activeInfoWindow) {
                    activeInfoWindow.close();
                }
                marker.info.open(map, marker);
                activeInfoWindow = marker.info;
            });

            // Add marker location to loc var
            var loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

            // extend bounds with loc
            bounds.extend(loc);

            var listEntry = document.createElement("li");
            var listEntryHeading = document.createElement("h4");
            listEntryHeading.appendChild(document.createTextNode(data.name))
            var listEntryAddress = document.createElement("p");
            listEntryAddress.appendChild(document.createTextNode(data.address))

            var listEntrySocial = document.createElement("ul");
            var listEntrySocialContent = '';

            if (www) {
                listEntrySocialContent+= '<li><a href="https://' + www + '" target="_blank" rel="nofollow">Webseite / Shop</a></li>';
            }
            if (fb) {
                listEntrySocialContent+= '<li><a href="https://www.facebook.com/' + fb + '/" target="_blank" rel="nofollow">Facebook</a></li>';
            }
            if (insta) {
                listEntrySocialContent+= '<li><a href="https://www.instagram.com/' + insta + '/" target="_blank" rel="nofollow">Instagram</a></li>';
            }

            listEntry.appendChild(listEntryHeading);
            listEntry.appendChild(listEntryAddress);

            if (listEntrySocialContent != '') {
                listEntry.appendChild(listEntrySocial);
                listEntrySocial.innerHTML = listEntrySocialContent;
            }


            sublist.appendChild(listEntry);

        });

    });

    setTimeout(function() {

        map.setCenter({lat:49.4, lng: 11.38});
        // map.fitBounds(bounds); // auto zoom
        // map.panToBounds(bounds); // auto center
        map.setZoom(6); // zoom a bit
    }, 500);


}


window.onload = function(e){
    initMap(); // init map
}
